export default __webpack_public_path__ + "media/images/og-image-30d962e5d78d13bf57ccbf60e57020cc.jpg";